export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'];
export const SOURCE_PARAMS = ['source_url', 'source_type', 'source_id'];

export const BASE_TRACKING_PARAMS = [
  'referrer',
  'landing_page',
  'partner_id',
  'promocode',
  'sscid',
  'discount',
  // GTM auto-tracking params
  '_gl',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  '_fbc',
  'li_fat_id',
  'rdt_cid',
  'qclid',
];

export const LC_TRACKING_PARAMS = [
  'coupon',
  'url' /* website  autofill */,
  'chat_purpose',
  'industry',
  'company_size',
  'country',
  'phone',
  'audience',
  'ghtests',
  'coupon_code',
  'promo_code',
  'discount_coupon',
  'region',
  'environment',
];

export const CB_TRACKING_PARAMS = [
  'onboardingLesson',
  'client_name',
  'partner_email',
  'purchase_order',
  '_state',
];

export const OW_TRACKINGPARAMS = ['preconfig'];

export const ALL_TRACKING_PARAMS = [
  ...UTM_PARAMS,
  ...SOURCE_PARAMS,
  ...BASE_TRACKING_PARAMS,
  ...LC_TRACKING_PARAMS,
  ...CB_TRACKING_PARAMS,
  ...OW_TRACKINGPARAMS,
];

export const GTM_EVENTS = {
  PRE_SIGNUP: 'Pre_Signup',
  NAVIGATE_TO_PRODUCT: 'cd_nav',
};

// Domains provided by MTA agency for which we want to send a dataLayer push when redirecting/opening links
export const MONITORED_EXTERNAL_DOMAINS: string[] = [
  'text.com',
  'lc.chat',
  'chatbot.com',
  'helpdesk.com',
  'livechat.com',
  'livechatinc.com',
];
